import api from '../api/api';
import { ws } from '../api/websocketApi';
import useStore from '../store/store';

const Logout = async () => {
    const setAccessToken = useStore.getState().setAccessToken;
    const setRefreshToken = useStore.getState().setRefreshToken;

    try {
        // Close WebSocket connection and reset internal WS state
        ws.closeClient();
        ws.clearInternalState();

        // Call API.
        const response = await api.post('/security/logout');

        // Deconstruct response.data.
        const { success } = response.data;

        if (success) {
            // Clear local storage
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('phone');

            // Update Axios header.
            api.defaults.headers.common.Authorization = `Bearer ${null}`;

            // Remove tokens
            setAccessToken(null);
            setRefreshToken(null);

            // Reload page
            window.location.reload(false);
        }
    } catch (e) {
        console.error(e);
        // Network Error (error code 17)
        //if (e.code) setFormError(e.code)
    }
};

export default Logout;
